import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

export async function fetchStockTransferDetail(id) {
  const { data: raw } = await request.get(`/ims/stock-transfer/${id}`);
  return parseVer4DetailResponse(raw);
}
